module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BCET2t/tc-custom/9781429944502.jpg?1738254612462",
      "alt": "This image is the cover for the book Our Life in Gardens"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Our Life in Gardens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is the third book we have written together, though separately we have written others . . . But to say ‘written separately' makes no sense, for when two lives have been bent for so many years on one central enterprise—in this case, gardening—there really is no such thing as separately.\" "), _c('br'), _c('br'), _vm._v("With these words, the renowned garden designers Joe Eck and Wayne Winterrowd begin their entertaining, fascinating, and unexpectedly moving book about the life and garden they share. The book contains much sound information about the cultivation of plants and their value in the landscape, and invaluable advice about Eck and Winterrowd's area of expertise: garden design. There are chapters about the various parts of their garden, and sections about particular plants—roses and lilacs, snowdrops and cyclamen—and vegetables. The authors also discuss the development of their garden over time, and the dark issue that weighs more and more on their minds: its eventual decline and demise. "), _c('i', [_vm._v("Our Life in Gardens ")]), _vm._v("is a deeply satisfying perspective on gardening, and on life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Eck, Wayne Winterrowd\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Roaring Brook Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0